import http from './axios';

export default class SuperviseServices {
  private readonly list_api = '/v1/supervise/alert-page';
  private readonly total_api = '/v1/supervise/alert-super-count'; // 预警总览
  private readonly export_api = '/v1/supervise/export'; // 导出预警Excel
  private readonly info_api = '/v1/supervise/info';
  private readonly ignore_api = '/v1/supervise/ignore';
  private readonly restart_api = '/v1/supervise/restart';
  private readonly list_origin_data_api = '/v1/supervise/query-orign-data';
  private readonly export_origin_data_api = '/v1/supervise/export-orign-data';

  constructor() {}

  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getOriginList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_origin_data_api, { params: params });
    return res.payload;
  }

  async getTotal(params?: object): Promise<any> {
    let res: any = await http.get(this.total_api, { params: params });
    return res.payload;
  }

  async ignore(params: any) {
    let res: any = await http.post(this.ignore_api, params);
    return res.header?.code == 200 ? true : false;
  }

  async restart(params: any) {
    let res: any = await http.post(this.restart_api, params);
    return res.header?.code == 200 ? true : false;
  }

  async downloadExcel(params?: object) {
    let res: any = await http.get(this.export_api, {
      headers: {
        responseType: 'arraybuffer'
      },
      responseType: 'arraybuffer',
      params: params,
    });
    return res;
  }

  async downloadOriginExcel(params?: object) {
    let res: any = await http.get(this.export_origin_data_api, {
      headers: {
        responseType: 'arraybuffer'
      },
      responseType: 'arraybuffer',
      params: params,
    });
    return res;
  }

}
